import { render } from "./match-schedule.vue?vue&type=template&id=3a67ac46&scoped=true"
import script from "./match-schedule.vue?vue&type=script&lang=js"
export * from "./match-schedule.vue?vue&type=script&lang=js"

import "./match-schedule.vue?vue&type=style&index=0&id=3a67ac46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a67ac46"]])

export default __exports__